module.exports = __webpack_public_path__ + "static/microsoft-logo-9f25fd5ac577ed77ecc4296acb15a610.png";